module.exports = __webpack_public_path__ + "a8aa3f8be0931ab064008f81df7ca4be.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logos/express-betalning.png
 ** module id = 1550
 ** module chunks = 1
 **/